/* Spyr landing v5 — hero video switching + Klaviyo email capture.
   Loaded (deferred) by the landing-hero and landing-close sections; the guard
   below makes the second include a no-op. */
(function () {
  'use strict';
  if (window.__spyrLandingV5) return;
  window.__spyrLandingV5 = true;

  /* --- Hero video ---------------------------------------------------------
     No <source> is declared in the markup on purpose. <source media="..."> is
     honoured inconsistently for <video>, so the cut is chosen here after a
     matchMedia check and exactly one file is ever fetched. Reduced motion
     attaches nothing and the poster stands in as a still. */
  function attachHeroVideo() {
    var video = document.querySelector('[data-lv5-video]');
    if (!video) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var isPhone = window.matchMedia('(max-width: 620px)').matches;
    var src = isPhone ? video.getAttribute('data-mobile-src') : video.getAttribute('data-desktop-src');
    var poster = isPhone ? video.getAttribute('data-poster-mobile') : video.getAttribute('data-poster-desktop');
    if (!src) return;

    if (poster) video.poster = poster;
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* --- Klaviyo email capture ---------------------------------------------
     Same client-subscriptions call as the existing signup section. 202 =
     accepted; double opt-in (if enabled on the list) proceeds from there. */
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  async function subscribe(accountId, listId, email, source) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(accountId);
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Spyr landing v5',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    });
    if (res.status !== 202 && !res.ok) {
      var body = null;
      try { body = await res.json(); } catch (_) {}
      var msg = body && body.errors && body.errors[0] && body.errors[0].detail;
      throw new Error(msg || ('Klaviyo subscription failed: ' + res.status));
    }
  }

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest && e.target.closest('[data-lv5-form]');
    if (!form) return;
    e.preventDefault();

    var emailInput = form.querySelector('[name="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var wrap = form.closest('[data-lv5-capture]') || form.parentElement;
    var successEl = wrap.querySelector('[data-lv5-success]');
    var errorEl = wrap.querySelector('[data-lv5-error]');

    var email = (emailInput.value || '').trim();
    if (!isValidEmail(email)) { emailInput.focus(); return; }

    var accountId = form.getAttribute('data-klaviyo-account');
    var listId = form.getAttribute('data-klaviyo-list');
    if (!accountId || !listId) {
      console.error('[landing-v5] missing Klaviyo account or list ID');
      return;
    }

    if (errorEl) errorEl.hidden = true;
    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Sending';

    try {
      await subscribe(accountId, listId, email, form.getAttribute('data-source'));
      form.hidden = true;
      var micro = wrap.querySelector('[data-lv5-micro]');
      if (micro) micro.hidden = true;
      if (successEl) successEl.hidden = false;
    } catch (err) {
      console.error('[landing-v5]', err);
      if (errorEl) errorEl.hidden = false;
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  });

  /* --- Fixed header: solid ground once the hero is scrolled --- */
  function initHeader() {
    var header = document.querySelector('[data-lv5-header]');
    if (!header) return;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initTopButton() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-lv5-top]');
      if (!btn) return;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    });
  }

  /* Mobile sticky bar: appears once the hero (with its own CTA) has fully
     scrolled out of view; in the closing signup section the CTA hides and
     only the return-to-top button stays. */
  function initMobileBar() {
    var bar = document.querySelector('.lv5-mobilebar');
    if (!bar) return;
    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    var hero = document.querySelector('.lv5-hero');
    var close = document.querySelector('.lv5-close');
    if (hero) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(hero);
    }
    if (close) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-endzone', entries[0].isIntersecting);
      }, { threshold: 0.15 }).observe(close);
    }
  }

  function init() {
    attachHeroVideo();
    initHeader();
    initTopButton();
    initMobileBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
